import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Panel } from '../../components/Panel'
import { visitorsApi } from '../../api/visitors'
import { PUBLICATION_NAMES } from '../../lib/format'
import { useVisitorsRange } from '../../lib/useVisitorsRange'
import { QueryProblem, Skeleton, VisitorsFrame, linkCls } from './VisitorsFrame'

export function VisitorsEvent() {
  const { pub = '', eventId = '' } = useParams()
  const { search } = useVisitorsRange()
  const okPub = Object.hasOwn(PUBLICATION_NAMES, pub)
  const id = /^\d+$/.test(eventId) ? Number(eventId) : null
  const q = useQuery({
    queryKey: ['visitors-event', id],
    queryFn: () => visitorsApi.event(id as number),
    enabled: okPub && id !== null,
  })
  const base = `/visitors/${pub}`
  const d = q.data
  const sid = d && typeof d.session_id === 'string' && d.session_id !== '-' && d.session_id !== '' ? d.session_id : null

  return (
    <VisitorsFrame
      pub={pub}
      valid={okPub}
      title={`Event ${eventId}`}
      crumbs={[{ label: 'Event' }]}
    >
      {id === null ? (
        <Panel accent="red">
          <p className="text-paper">Not found</p>
          <Link to={`${base}?${search}`} className={`${linkCls} font-mono text-[12px]`}>Back to the title page</Link>
        </Panel>
      ) : q.isError ? (
        <QueryProblem error={q.error} pub={pub} />
      ) : !d ? (
        <Skeleton />
      ) : (
        <>
          {sid && (
            <Link to={`${base}/sessions/${encodeURIComponent(sid)}?${search}`} className={`${linkCls} font-mono text-[12px]`}>
              ← Back to this visit
            </Link>
          )}
          <Panel accent="violet">
            <pre className="font-mono text-[12px] text-paper whitespace-pre-wrap break-words overflow-x-auto">{JSON.stringify(d, null, 2)}</pre>
          </Panel>
          <p className="font-mono text-[11px] text-paper-faint">
            subscriber_id is added on the server from the session, never sent by the browser. The IP is used for country and bot checks, then kept only as a /24 hash.
          </p>
        </>
      )}
    </VisitorsFrame>
  )
}
